import React from 'react';
import { cn } from '@/lib/utils.ts';

/**
 * Informacja drugorzędna w komórce: waluta, grosze, rok, limit, kraj, godzina.
 *
 * W komórce jest jedna wartość główna i najwyżej jedna taka — przy kilkunastu
 * kolumnach oko ma widzieć kolumnę wartości, a nie ścianę znaków.
 */
export const CellSecondary = ({
  className,
  ...props
}: React.ComponentProps<'span'>) => (
  <span className={cn('text-neutral-400', className)} {...props} />
);
